import React from "react";
import { useClearRefinements } from "react-instantsearch";
import Button from "@mui/material/Button";

const LegalbirdClearRefinements = () => {
  const { canRefine, refine } = useClearRefinements();

  return (
    <Button onClick={refine} disabled={!canRefine}>
      Filter entfernen
    </Button>
  );
};

export default LegalbirdClearRefinements;
